import PageTabTitle from "../../../global/components/PageTabTitle/PageTabTitle.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";
import SitzungModalCreate from "../SitzungModalCreate/SitzungModalCreate.vue";
import SmartTable from "../../../global/components/table/table.vue";

import getTableApi from "../../../const/TableApis";

const TABLE_ID = "sitzung";

// @vue/component
export default {
  name: "SitzungList",
  components: {
    PageTabTitle,
    PuxTranslate,
    SitzungModalCreate,
    SmartTable,
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: getTableApi({ id: TABLE_ID }),
        rowActions: [
          {
            label: "_LBL_SITZUNG_LIST_ACTIONS_ROW_DETAILS_",
            route: "root.sitzungen.details",
            routeParameters: [{ routeId: "id", rowPath: "pk" }],
          },
        ],
        actions: [
          {
            permission: "sitzungen.create",
            label: "_LBL_SITZUNG_LIST_NEUE_SITZUNG_ERSTELLEN_",
            callback: () => this.modal.create = true,
            type: "button",
            className: "btn btn-primary test_create_sitzung",
            icon: "glyphicon-plus",
            htmlId: "sitzung_create",
          },
        ],
        label: "_LBL_SITZUNG_LIST_SITZUNGEN_",
        sortable: true,
        pagination: true,
        details: false,
        view: {
          filter: "top",
        },
      },
      modal: {
        create: undefined,
      },
    };
  },
  methods: {
    closeModalCreate() {
      this.modal.create = false;
    },
  },
};
